import { ReactNode } from 'react';
import { OverlayContainer } from 'react-aria';

import Icon from '~/components/scales/Icon/Icon';
import IconButton from '~/components/scales/IconButton/IconButton';

type Props = {
  children: ReactNode;
  /** Nodes rendered in the footer must have a height <= 40px */
  footerLeft?: ReactNode;
  /** Nodes rendered in the footer must have a height <= 40px */
  footerRight?: ReactNode;
  isOpen: boolean;
  onClose: () => void;
  title: ReactNode;
};

export default function Sidebar(props: Props) {
  if (!props.isOpen) {
    return null;
  }

  return (
    <OverlayContainer>
      <aside className="fixed bottom-0 right-0 top-0 z-50 flex w-[600px] flex-col bg-background-primary text-type-primary shadow-leftwards outline-none">
        <Header onClose={props.onClose} title={props.title} />
        <div className="flex-grow overflow-y-auto">{props.children}</div>
        <Footer left={props.footerLeft} right={props.footerRight} />
      </aside>
    </OverlayContainer>
  );
}

function Header(props: { title?: Props['title']; onClose: () => void }) {
  return (
    <header className="flex h-20 items-center justify-between gap-2 px-6 py-4">
      <h3 className="type-heading2">{props.title}</h3>
      <IconButton
        aria-label="close sidebar"
        icon={<Icon name="close" />}
        onClick={props.onClose}
        type="secondary"
      />
    </header>
  );
}

function Footer(props: { left?: ReactNode; right?: ReactNode }) {
  if (!props.left && !props.right) return null;
  return (
    <div className="flex flex-col">
      <div className="h-px w-full flex-shrink-0 bg-border-default" />
      <footer className="flex items-center justify-between p-6">
        <div className="flex h-10 items-center">{props.left}</div>
        <div className="flex h-10 items-center">{props.right}</div>
      </footer>
    </div>
  );
}
